/* The Source column, shared by the admissions and students tables.

   Where a person heard about the college. When that source is an agency the
   cell is the way into that agency's profile, which is the whole point of
   asking: a row that says "Agency" and makes you go and search for which one
   answers nothing.

   The link is rendered as a real anchor so it can be opened in a new tab and
   copied, but the click is handed to the router through `onOpenAgency` — both
   tables sit inside a clickable row, so the click also has to stop there rather
   than opening the person underneath it. */

import { Building2 } from 'lucide-react';
import { heardAboutLabel, heardAboutOf, HEARD_ABOUT_AGENCY } from '@/lib/heardAbout';

export function agencyHref(agentId) {
  return agentId ? `/admin/agencies/${agentId}` : '';
}

export default function SourceCell({ record, onOpenAgency }) {
  const { code, detail, agentId, agencyName } = heardAboutOf(record);

  if (!code) return <span className="text-[#062B1A]/40">Not provided</span>;

  const label = heardAboutLabel(code);
  // An agency source without a linked profile still says "Agency" — the
  // applicant named one, we just have not matched it to a record yet.
  const linked = code === HEARD_ABOUT_AGENCY && agentId;

  return (
    <div className="min-w-0">
      <p className="text-sm text-[#062B1A]">{label}</p>
      {linked ? (
        <a
          href={agencyHref(agentId)}
          onClick={(event) => {
            event.stopPropagation();
            if (!onOpenAgency) return;
            event.preventDefault();
            onOpenAgency(agentId);
          }}
          className="mt-0.5 inline-flex items-center gap-1 truncate text-xs text-[#7A5A05] underline decoration-[#D4AF37]/60 underline-offset-2 hover:text-[#D4AF37]"
        >
          <Building2 className="h-3 w-3 shrink-0" />
          {agencyName || 'Open agency'}
        </a>
      ) : detail ? (
        <p className="mt-0.5 truncate text-xs text-[#062B1A]/55">{detail}</p>
      ) : null}
    </div>
  );
}
